module.exports = __webpack_public_path__ + "img/day-1.9c37bbaa.png";